import { Nav } from "@/components/landing/Nav";
import { EnquiryPopup } from "@/components/landing/EnquiryPopup";
import { Hero } from "@/components/landing/Hero";
import { ModelCompare } from "@/components/landing/ModelCompare";
import { TrackRecord } from "@/components/landing/TrackRecord";
import { Projects } from "@/components/landing/Projects";
import { Segments } from "@/components/landing/Segments";
import { WhyChoose } from "@/components/landing/WhyChoose";
import { Reviews } from "@/components/landing/Reviews";
import { FinalCta } from "@/components/landing/FinalCta";
import { Contact } from "@/components/landing/Contact";
import { Footer } from "@/components/landing/Footer";

export default function Landing() {
  return (
    <main className="bg-paper text-navy">
      <Nav />
      <EnquiryPopup />
      <Hero />
      <ModelCompare />
      <TrackRecord />
      <Projects />
      <Segments />
      <WhyChoose />
      <Reviews />
      <FinalCta />
      <Contact />
      <Footer />
    </main>
  );
}
